import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: auto;
  border-radius: ${props => props.theme.radius.md};
  padding: 12px 18px;
  justify-content: space-between;
  margin-bottom: 18px;
`;
